/**
 * Copy for the playlist player's non-playing states.
 *
 * PR 4 of the Feedback Player UX redesign — the plan calls out the
 * legacy "No playable notes" copy as inaccurate and asks for
 * "You're all caught up." on the completion state. The two cases
 * need different copy:
 *
 *   - **finished**: the user worked through every item and the
 *     session reset itself to `null`. Show the completion title +
 *     body that prompt either Review again or Back to feedback.
 *   - **empty bundle**: the playlist genuinely has no items the
 *     viewer can see (or no items at all). Show a friendly
 *     no-items message — items are "review items", not "playable
 *     notes" on the player surface.
 */

export type PlaylistFallbackKind = "finished" | "empty";

export function playlistFallbackCopy(
  itemCount: number,
  kind: PlaylistFallbackKind = itemCount > 0 ? "finished" : "empty",
): {
  title: string;
  body: string;
} {
  if (kind === "finished") {
    return {
      title: "You're all caught up.",
      body: "No more items to review in this session.",
    };
  }
  return {
    title: "Nothing in this session yet.",
    body:
      "Your coach hasn't added any review items here. Check the Review tab for other feedback to work through.",
  };
}
